import React from 'react';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';

import useMantenimiento from 'src/hooks/useMantenimiento';
import { hayBloqueo, queSeBloquea } from 'src/utils/mantenimiento';

// Aviso rojo arriba del dashboard mientras haya un bloqueo activo, para que nadie lo olvide encendido.
export default function MantenimientoBanner() {
  const { estado } = useMantenimiento();
  if (!hayBloqueo(estado)) return null;

  const hasta = estado.hasta ? new Date(estado.hasta).toLocaleString() : null;
  return (
    <Alert severity='error' style={{ marginBottom: 16 }}>
      <AlertTitle>Mantenimiento activo</AlertTitle>
      Está bloqueada {queSeBloquea(estado)}. {estado.mensaje}
      {hasta ? ` (se levanta solo el ${hasta})` : ''}
    </Alert>
  );
}
